export const keyStageOptions = [
    {
        id: '1',
        name: 'Key stage 1',
        yearGroups: [
            {
                id: '1',
                name: 'Year 1',
            },
            {
                id: '2',
                name: 'Year 2',
            },
        ],
    },
    {
        id: '2',
        name: 'Key stage 2',
        yearGroups: [
            {
                id: '3',
                name: 'Year 3',
            },
            {
                id: '4',
                name: 'Year 4',
            },
            {
                id: '5',
                name: 'Year 5',
            },
            {
                id: '6',
                name: 'Year 6',
            },
        ],
    },
    {
        id: '3',
        name: 'Key stage 3',
        yearGroups: [
            {
                id: '7',
                name: 'Year 7',
            },
            {
                id: '8',
                name: 'Year 8',
            },
            {
                id: '9',
                name: 'Year 9',
            },
        ],
    },
    {
        id: '4',
        name: 'Key stage 4',
        yearGroups: [
            {
                id: '10',
                name: 'Year 10',
            },
            {
                id: '11',
                name: 'Year 11',
            },
        ],
    },
];

export const stateStandardOptions = [
    { id: 'CCSS (Common Core)', name: 'CCSS (Common Core)' },
    { id: 'TEKS (Texas)', name: 'TEKS (Texas)' },
    { id: 'BEST (Florida)', name: 'BEST (Florida)' },
    {
        id: 'NYS Next Generation (New York)',
        name: 'NYS Next Generation (New York)',
    },
    { id: 'SOL (Virginia)', name: 'SOL (Virginia)' },
    { id: 'CAS (Colorado)', name: 'CAS (Colorado)' },
];

export const gradeOptions = [
    { id: '3', name: 'Grade 3' },
    { id: '4', name: 'Grade 4' },
    { id: '5', name: 'Grade 5' },
    { id: '6', name: 'Grade 6' },
    { id: '7', name: 'Grade 7' },
    { id: '8', name: 'Grade 8' },
];
